import { render, staticRenderFns } from "./Contactus.vue?vue&type=template&id=70fd1e0c&scoped=true&"
import script from "./Contactus.vue?vue&type=script&lang=js&"
export * from "./Contactus.vue?vue&type=script&lang=js&"
import style0 from "./Contactus.vue?vue&type=style&index=0&id=70fd1e0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd1e0c",
  null
  
)

export default component.exports